import { useEffect, useContext } from "react";
import { GlobalContext } from "../../context/GlobalState.jsx";
import { LearningContentLayout } from "../../shared/ui/Learning/LearningContentLayout.jsx";
import SubjectList from "../../shared/domain/learning/components/SubjectList.jsx";
import { cleanURLPath } from "../../shared/utils/url.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";

export default function Subjects() {
  const history = useHistory();
  const { userDetails, setUserDetails, allSubjects, subLoading } =
    useContext(GlobalContext);

  useEffect(() => {
    setUserDetails({
      ...userDetails,
      selectedTab: "2Xcell Resources",
      selectedPath: {
        subject: "",
        chapter: "",
        topic: "",
      },
    });
  }, []);

  const openSubject = (subject) => {
    history.push(
      `/learningresources/${cleanURLPath(subject?.subject)}/${
        subject.subjectId
      }`,
    );
  };

  return (
    <LearningContentLayout
      grade={userDetails.grade + "-" + userDetails.section}
      resourcePage={"Subjects"}
    >
      <SubjectList
        subjects={allSubjects}
        loading={subLoading}
        onClick={openSubject}
      />
    </LearningContentLayout>
  );
}
